import styled from 'styled-components';

export const Container = styled.div`
    height: 160px;
    width: 420px;
    position: 'relative';
`;

export const ContainerRow = styled.div`
    display: flex;
    height: 60px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px 0px 20px;
`;

export const TextExit = styled.span`
    font-size: 22px;
    color: black;
    font-family: NunitoSans-Bold;
`;

export const CloseButton = styled.button`
    background-color: grey;
    width: 30px;
    height: 30px;
    border: 1px solid grey;
    border-radius: 50%;
    color: white;

    &:hover {
        cursor: pointer;
    }
`;

export const ExitButton = styled.button`
    background-color: #341ae8;
    border: 1px solid grey;
    height: 50px;
    width: 125px;
    border-radius: 8px;
    font-family: NunitoSans-Regular;
    color: white;
    font-size: 18px;
    position: absolute;
    right: 20px;
    bottom: 20px;

    &:active {
        opacity: 0.5;
    }
`;
